module.exports = __webpack_public_path__ + "assets/img/contact.482ca33f.svg";